var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('location-editor',{attrs:{"payload":{ location: _vm.location, resource_type: 'Position', resource_id: _vm.payload.position_id }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }